import { FormlyFieldConfig } from '@ngx-formly/core';
import {
  getInputField,
  setAsRequired,
  getSelectField,
  setRegexValidation,
  getDateField,
  getTypeAheadField, getJustaButton, setHideButtonWhen, getMergedConfig, getConfigurableTypeAhead, setStatusNotAllowed, getEmpProfileSelectField
  // getMultiFormConfig,
  // getMultiFormActivateButton
} from 'src/app/shared/form';
import { CommonService } from "src/app/core/common.service";
import { LookupTypeKeys } from "src/app/shared/lookup-type-keys";
import { EMPTY, Observable, Subscription } from 'rxjs';
import { LookupField, RoleType, Employee, Companies, ExitJobCategory, Speciality } from 'src/app/core/api.gen';
import { distinctUntilChanged, map, startWith, tap } from 'rxjs/operators';
import { isNullOrUndefined, isUndefined } from '../../../../app/core/utils';
import { nullSafe } from 'src/app/utils';
import { ExitStatusTypeIds } from 'src/app/shared/exit-status-types';
import { AbstractControl } from '@angular/forms';
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';

export class CommonExitInputs {

  protected nationality$: Observable<LookupField[]>;
  protected officeLocations$: Observable<LookupField[]>;
  //same as officeLocation$
  protected officeLocationWithBehaviourSub$: Observable<LookupField[]>;
  protected exitTypes$: Observable<LookupField[]>;
  protected serviceLines$: Observable<LookupField[]>;
  protected shortNotice$: Observable<LookupField[]>;
  protected subServiceLines$: Observable<LookupField[]>;
  protected subSubServiceLines$: Observable<LookupField[]>;
  protected ranks$: Observable<LookupField[]>;
  protected officeLocationCountry$: Observable<LookupField[]>;
  protected onBoardingTypes$: Observable<LookupField[]>;
  protected exitApprovers$: Observable<Employee[]>;
  protected exitSubTypes$: Observable<LookupField[]>;
  protected status$: Observable<LookupField[]>;
  protected gender$: Observable<LookupField[]>;
  protected exitEmpCategory$: Observable<LookupField[]>;
  protected companies$: Observable<Companies[]>;
  protected jobCategory$: Observable<ExitJobCategory[]>;
  protected smus$: Observable<LookupField[]>;
  protected sectors$: Observable<LookupField[]>;
  protected yesNo$: Observable<LookupField[]>;
  protected letterToUsed$: Observable<LookupField[]>;
  protected reasonOfSeperation$: Observable<LookupField[]>;
  protected applicationOfNotice$: Observable<LookupField[]>;
  protected specialities$: Observable<LookupField[]>;
  protected cancellationVisas$: Observable<LookupField[]>;
  protected nationalityType$: Observable<LookupField[]>;
  protected officeLocationCountries$: Observable<LookupField[]>;
  


  constructor(
    public common: CommonService) {
    this.loadExitLookups();
  }

  fil(item: LookupField[]): LookupField[] {
    item = item.filter(i =>
      i.id !== ExitStatusTypeIds.PENDING
      && i.id !== ExitStatusTypeIds.DRAFT
      && i.id !== ExitStatusTypeIds.DECLINED
      && i.id !== ExitStatusTypeIds.EXTENDED
    );
    item.find(i => i.id === ExitStatusTypeIds.COMPLETED).disabled = true;
    return item;
  }

  firstName(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getInputField(
      "firstName",
      "First name (as per passport)",
      setAsRequired(setRegexValidation(/^[a-zA-Z -]*$/, 'Please enter a valid name', additionalConfig))
    );
  }

  middleName(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getInputField(
      "middleName",
      "Middle name (as per passport)",
      setRegexValidation(/^[a-zA-Z -]*$/, 'Please enter a valid name', additionalConfig)
    );
  }

  lastName(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getInputField("lastName", "Last name (as per passport)",
      setAsRequired(setRegexValidation(/^[a-zA-Z -]*$/, 'Please enter a valid name', additionalConfig)));
  }
  pocTalent(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getTypeAheadField("pocTalent", "Poc Talent", setAsRequired(additionalConfig));
  }
 

  applicationOfNotice(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getSelectField(
      "applicationOfNotice.id",
      "Application of notice",
      this.common.getSelectFieldOptions(this.applicationOfNotice$, '', setAsRequired(additionalConfig))
    );
  }

  employeeName(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getInputField(
      "employeeName",
      "Employee Name",
      setAsRequired()
    );
  }


  firmJoiningDate(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField("joiningDate", "Firm joining date", setAsRequired(
      setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
        "Please enter a valid date in 'dd-mm-yyyy' format", additionalConfig)));
  }

  exitRank(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getSelectField(
      "job.rank",
      "EY rank name",
      this.common.getExitRankSelectFieldOptions(
        setAsRequired(additionalConfig))
    );
  }

  exitGrade(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getSelectField(
      "job.jobCode",
      "EY grade name",
      this.common.getExitGradeSelectFieldOptions(additionalConfig)
    );
  }

  company(additionalConfig?: FormlyFieldConfig) {
    return getSelectField(
      "company.id",
      "Legal Entity",
      this.common.getLeBasedOnOfficeLoc(setAsRequired(additionalConfig)
      )
    );
  }

  gender(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getSelectField("genderCode.id", "Gender", this.common.getSelectFieldOptions(this.gender$, '', setAsRequired(additionalConfig)));
  }


  competency(additionalConfig?: FormlyFieldConfig) {
    return getSelectField(
      "competency.id",
      "Competency",
      this.common.getSelectFieldOptions(this.smus$, "subServiceLine.id", setAsRequired())
    );
  }

  industryData(additionalConfig?: FormlyFieldConfig) {
    return getSelectField(
      "industryData.id",
      "Industry data",
      this.common.getSelectFieldOptions(this.sectors$.pipe(map(item=>item.filter(i=>![4881,4882,4883,4884,4885].includes(i.id)))),
        "", additionalConfig)
    );
  }

  employeeCategory(additionalConfig?: FormlyFieldConfig) {
    return getSelectField(
      "employeeCategory.id",
      "Employee category",
      this.common.getSelectFieldOptions(this.exitEmpCategory$, "",
        setAsRequired(additionalConfig)
      )
    );
  }

  exitReason(additionalConfig?: FormlyFieldConfig) {
    return getSelectField(
      "exitReason.id",
      "Exit reason",
      this.common.getSelectFieldOptions(this.officeLocations$, "",
        setAsRequired(additionalConfig)
      )
    );
  }

  VolInvolIndicator(additionalConfig?: FormlyFieldConfig) {
    return getSelectField(
      "volInvolIndicator.id",
      "Voluntary involuntary indicator",
      this.common.getSelectFieldOptions(this.officeLocations$, "",
        setAsRequired(additionalConfig)
      )
    );
  }


  nationality(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getSelectField("nationality.id", "Nationality", this.common.getSelectFieldOptions(this.nationality$, '',
      setAsRequired(additionalConfig)));
  }

  noticePeriod(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getInputField(
      "durationOfNoticeInDays",
      "Notice Period",
      setAsRequired()
    );
  }

  dateTermination(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField("dateTerminationCommunicated", "Date termination  communicated (to employee)", setAsRequired(
      setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
        "Please enter a valid date in 'dd-mm-yyyy' format", additionalConfig)));
  }



  
  lastWorkingDate(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField("lastWorkingDate", "Last working date", setAsRequired(
      setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
        "Please enter a valid date in 'dd-mm-yyyy' format", additionalConfig)));
  }
 
 

  department(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getSelectField("department.id", "Department", this.common.getDepartBySMUSelectFieldOption(additionalConfig));
  }



  jobName(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getSelectField("jobName.id", "Job Name", this.common.getSelectFieldOptions(this.nationality$, '',
      setAsRequired(additionalConfig)));
  }

  employeeCurrentLocation(additionalConfig?: FormlyFieldConfig, label = "Office location"): FormlyFieldConfig {
    return getConfigurableTypeAhead("employeeCurrentLocation", label,
      this.addOfficeLocationTypeAheadEndPoint(additionalConfig)
    );
  }

  officeLocation(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getSelectField(
      "officeLocation.id",
      "Location city",
      this.common.getSelectFieldOptions(this.officeLocations$.pipe(map(item => item.filter(i => ![6254].includes(i.id)))),
       '', setAsRequired(additionalConfig)
      )
    );
  }




  // officeLE(label: string, additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  //   return getSelectField(
  //     "officeLE.id",
  //     label,
  //     this.common.getSelectFieldOptions(this.officeLE$, '', setAsRequired(additionalConfig))
  //   );
  // }


  gpn(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getInputField(
      "gpn",
      "GPN",
      additionalConfig
    );
  }
  lpn(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getInputField(
      "lpn",
      "LPN",
      additionalConfig
    );
  }

  gpnGuiSearchButton(operations) {
    return !isNullOrUndefined(operations) ? this.button(operations, 'Autofill with GPN & GUI', 'outline-primary',
      setHideButtonWhen((model) =>
        !isUndefined(model['status'].id)
        && ![10850, 10853].includes(nullSafe<number>(() => model['status'].id, -1))
      )) : {}
  }

  button(operations: () => string[], buttonLabel: string, btnType: string, additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getJustaButton(operations, buttonLabel, btnType, additionalConfig);
  }

  gui(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getInputField(
      "gui",
      "GUI",
      additionalConfig
    );
  }



  exitDate(label = 'Date Of Release', additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
   const exitDateConfig = getDateField(
    "dateOfExit",
    label,
    setAsRequired(
      setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
        "Please enter a valid date in 'dd-mm-yyyy' format")))
        exitDateConfig.hooks = {
          onInit: (field) => {
           
            let previousValue = field.formControl.value; 
            const shortNoticeEle = this.findFormControl('shortNotice.id', field);
            const valueChangesSubscription = field.formControl.valueChanges.pipe(
              startWith(previousValue), // Set an initial value
              distinctUntilChanged()
            ).subscribe((newValue) => {

              let createdDate = field.model.createdDate;
              createdDate= isNullOrUndefined(createdDate)? new Date():createdDate ;
               const datediff = differenceInCalendarDays(newValue,createdDate);
              if (0<=datediff && datediff<15) {
               shortNoticeEle.setValue(1074)
              }
              else{
               shortNoticeEle.setValue(1075)
              }
              previousValue = newValue; // Update the previous value
            });
          },
        };
        return exitDateConfig;
    
  }
  shortNotice(label,additionalConfig?:FormlyFieldConfig):FormlyFieldConfig{
    return getSelectField("shortNotice.id",label,this.common.getSelectFieldOptions(this.shortNotice$, '',
    additionalConfig))
    
  }
  ExitDateChanged(label,additionalConfig?:FormlyFieldConfig):FormlyFieldConfig{
    return getSelectField("exitDateChanged.id",label,this.common.getSelectFieldOptions(this.yesNo$, '',
    additionalConfig))
  }
  exitDateWithAlert(label = 'Date Of Release', additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {    
    const dateFieldConfig = getDateField(
      "dateOfExit",
      label,
      setAsRequired(
        setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
          "Please enter a valid date in 'dd-mm-yyyy' format")
      )
    );  
    dateFieldConfig.hooks = {
      onInit: (field) => {
        let previousValue = field.formControl.value; 
        const shortNoticeEle = this.findFormControl('shortNotice.id', field);
        const valueChangesSubscription = field.formControl.valueChanges.pipe(
          startWith(previousValue), // Set an initial value
          distinctUntilChanged()
        ).subscribe((newValue) => {
          if (previousValue!=null && newValue!=null) {
            const previousDatePart = new Date(previousValue.getFullYear(), previousValue.getMonth(), previousValue.getDate());
            const newDatePart = new Date(newValue.getFullYear(), newValue.getMonth(), newValue.getDate());
            if(previousDatePart.getTime() !== newDatePart.getTime())
            {
            this.common.OpenAlert("Please update the Medical insurance cancellation effective date as well");
            } 
          }
          let createdDate = field.model.createdDate;
          createdDate= isNullOrUndefined(createdDate)? new Date():createdDate ;
           const datediff = differenceInCalendarDays(newValue,createdDate);
          if (0<=datediff && datediff<15) {
           shortNoticeEle.setValue(1074)
          }
          else{
           shortNoticeEle.setValue(1075)
          }
          previousValue = newValue; // Update the previous value
        });
    
        // // Unsubscribe from valueChanges when the field is destroyed to avoid memory leaks
        // field.onDestroy = () => {
        //   valueChangesSubscription.unsubscribe();
        // };
      },
    };
  
    return dateFieldConfig;
  }
  miCancellationDate(label = 'Medical insurance cancellation effective date', additionalConfig?: FormlyFieldConfig):  FormlyFieldConfig {
    return getDateField(
      "miCancellationDate",
      label,
      setAsRequired(
        setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
          "Please enter a valid date in 'dd-mm-yyyy' format")));
  }
  getNationalityType(dataSource$: Observable<LookupField[]>){
    const olc$ = this.common.prepareLookupObservable(LookupTypeKeys.OFFICE_LOCATION);
    let officelocationcity;
    olc$.subscribe(res =>{officelocationcity=res;})
    const nationalityTypeConfig = getSelectField(
      "nationalityTypeId.id",
      "Nationality Type",setAsRequired()
    );
   
    nationalityTypeConfig.templateOptions.valueProp="id";
    nationalityTypeConfig.templateOptions.labelProp= "displayText";
   
    nationalityTypeConfig.hooks = {
      onInit: field => {
        const ele = this.findFormControl('officeLocation.id', field);
        ele.valueChanges
          .pipe(
            startWith(ele.value),
            tap(id => {
              const parentId=officelocationcity?.find(x=>x.id==ele.value)?.parentFieldId;
              if (!isNullOrUndefined(parentId) && (parentId === 1048)) {//KSA
                field.templateOptions.options = EMPTY;
                field.templateOptions.options = dataSource$.pipe(map(items => items.filter(f => ![14573].includes(f.id))));              
              }
              else if (!isNullOrUndefined(parentId) && (parentId ===1047)){//UAE
                field.templateOptions.options = EMPTY;
                field.templateOptions.options = dataSource$.pipe(map(items => items.filter(f => ![15233].includes(f.id)))); 
              }
              else {
                field.templateOptions.options = EMPTY;
                field.templateOptions.options = dataSource$.pipe(map(items => items.filter(f => ![14573,15233].includes(f.id))));
              }
            })
          )
          .subscribe();
      }
    };
    return nationalityTypeConfig;
  }

  findFormControl(path: string, field: FormlyFieldConfig): AbstractControl {
    const form = field.parent.formControl;
    const control = form.get(path);
    if (control) {
      return control;
    }
    const emptyarr: Array<AbstractControl> = [];
    const forms = nullSafe(() => field.parent.formControl.parent.controls, emptyarr);
    for (const fc of forms) {
      const ctrl = fc.get(path);
      if (ctrl) {
        return ctrl;
      }
    }
    return null;
  }

  seniorityDate(label = 'Seniority date', additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getDateField(
      "seniorityDate",
      label,
      setAsRequired(
        setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
          "Please enter a valid date in 'dd-mm-yyyy' format")));
  }

  exitProcessor(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getSelectField(
      "offboardingMember.id",
      "Offboarding team member",
      setAsRequired(this.common.getEmployeeSelectFieldOptions(this.exitApprovers$, additionalConfig)));

  }
  status(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getSelectField("status.id", "Exit request status", this.common.getSelectFieldOptions(
      this.status$.pipe(map(item => this.fil(item))), '',
      setAsRequired(setStatusNotAllowed(ExitStatusTypeIds.ACCEPTED, "Please change status before saving"))));
  }
  // exitSubTypes(label: string, additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  //   return getSelectField(
  //     "exitSubType.id",
  //     label,
  //     this.common.getSelectFieldOptions(this.exitTypes$, '', setAsRequired(additionalConfig))
  //   );
  // }


  exGratiaAmount(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getInputField(
      "exGratiaAmount",
      "Ex-Gratia Amount",
      additionalConfig
    );
  }

  ticketNumber(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getInputField(
      "ticketNumber",
      "Ticket number",
      setAsRequired());
  }

  loadExitLookups() {



    this.nationality$ = this.common.prepareLookupObservable(
      LookupTypeKeys.NATIONALITY
    );
    
    this.nationalityType$ = this.common.prepareLookupObservable(
      LookupTypeKeys.NATIONALITY_TYPE);

    this.officeLocations$ = this.common.prepareLookupObservable(
      LookupTypeKeys.OFFICE_LOCATION
    );

    this.exitApprovers$ = this.common.prepareEmployeeByRoleObservable(
      RoleType.ExitTeam);

    this.gender$ = this.common.prepareLookupObservable(
      LookupTypeKeys.GENDER
    );


    //this.exitTypes$ = this.common.getAllExitSubTypes();

    this.serviceLines$ = this.common.prepareServiceLineObservable();
    this.subServiceLines$ = this.common.prepareSubServiceLineObservable();
    this.subSubServiceLines$ = this.common.prepareSMUObservable();
    this.sectors$ = this.common.prepareSectorObservable();
    this.ranks$ = this.common.prepareLookupObservable(LookupTypeKeys.RANK);
    this.onBoardingTypes$ = this.common.prepareLookupObservable(
      LookupTypeKeys.ONBOARDING_TYPES
    );
    this.shortNotice$ = this.common.prepareLookupObservable(
      LookupTypeKeys.YESNO_TYPES
    );

    this.status$ = this.common.prepareLookupObservable(
      LookupTypeKeys.EXIT_STATUSES
    );

    this.exitSubTypes$ = this.common.getExitSubTypes();
    this.exitEmpCategory$ = this.common.getExitJobCateogory();
    this.smus$ = this.common.prepareSMUObservable();
    this.specialities$ = this.common.prepareSpecialityObservable();

    this.yesNo$ = this.common.prepareLookupObservable(LookupTypeKeys.YESNO_TYPES);

    this.applicationOfNotice$ = this.common.prepareLookupObservable(LookupTypeKeys.APPLICATION_OF_NOTICE);
    this.reasonOfSeperation$ = this.common.prepareLookupObservable(LookupTypeKeys.REASON_OF_SEPERATION);
    this.letterToUsed$ = this.common.prepareLookupObservable(LookupTypeKeys.LETTER_TO_BE_USED);
    
  }




  AddTooltipToControl(tooltipMessage: string): FormlyFieldConfig {
    return {
      templateOptions: {
        tooltip: {
          content: tooltipMessage
        }
      },
      wrappers: ['tooltip-field']
    };
  }

  addOfficeLocationTypeAheadEndPoint(additionalConfig?: FormlyFieldConfig) {
    const config: FormlyFieldConfig = {
      templateOptions: {
        typeAheadEndPoint: (x) => this.common.getOfficeLocations(x)
      }
    };

    return getMergedConfig(config, additionalConfig);
  }

  addAllOfficeLocationTypeAheadEndPoint(additionalConfig?: FormlyFieldConfig) {
    const config: FormlyFieldConfig = {
      templateOptions: {
        typeAheadEndPoint: (x) => this.common.getAllOfficeLocations(x)
      }
    };

    return getMergedConfig(config, additionalConfig);
  }

  EmpProfileSearch(additionalConfig?: FormlyFieldConfig, operations?): FormlyFieldConfig {
    return getEmpProfileSelectField(
      "employeeSearchTerm",
      "Employee name",
      operations,
      additionalConfig
    );
  }

  internFil(item: LookupField[]): LookupField[] {
    item = item.filter(i =>
      i.id === ExitStatusTypeIds.INPROCESS
      || i.id === ExitStatusTypeIds.COMPLETED
      || i.id === ExitStatusTypeIds.ACCEPTED
    );
    item.find(i => i.id === ExitStatusTypeIds.COMPLETED).disabled = true;
    item.find(i => i.id === ExitStatusTypeIds.ACCEPTED).disabled = true;
    return item;
  }

  internStatus(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return getSelectField("status.id", "Exit request status", this.common.getSelectFieldOptions(
      this.status$.pipe(map(item => this.internFil(item))), '',
      setAsRequired(setStatusNotAllowed(ExitStatusTypeIds.ACCEPTED, "Please change status before saving"))));
  }




}
